import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import Select from 'components/select';
import { useRecoilState } from 'recoil';
import { OrderPayload } from 'pages/myidm/store';
import { InputInfo } from 'pages/myidm/components/input-info';

const ActiveDirectoryGroupType = ({ index }) => {
    const [isTouched, setIsTouched] = React.useState(false);
    const [order, setOrder] = useRecoilState(OrderPayload);
    const [options, setOptions] = React.useState([]);

    const currentValue = index !== undefined ? order?.multipleResourceGroups?.[index]?.activeDirectoryGroupType : order?.activeDirectoryGroupType;

    const setActiveDirectoryGroupType = (activeDirectoryGroupType) => {
        const updatedGroups = [...(order?.multipleResourceGroups || [])];
        updatedGroups[index] = {
            ...updatedGroups[index],
            activeDirectoryGroupType,
        };
        setOrder({
            ...order,
            multipleResourceGroups: updatedGroups,
        });
    };

    const handleOnSelectChange = (selected) => {
        setActiveDirectoryGroupType(selected.value);
    };

    React.useEffect(() => {
        setOptions([
            { label: 'Privileged', value: 'Privileged' },
            { label: 'Non-Privileged', value: 'Non-Privileged' },
        ]);
        // eslint-disable-next-line
    }, []);

    React.useEffect(() => {
        if (!currentValue && order?.isTouched) setIsTouched(true);
    }, [currentValue, order?.isTouched]);

    return (
        <Box display="flex" alignItems="center" gap={1}>
            <Select
                sx={{ marginTop: 0 }}
                key={`active-directory-group-type-${index !== undefined ? index : 'single'}`}
                label="Active Directory Group Type *"
                value={currentValue || null}
                options={options}
                handleOnSelect={(value) => handleOnSelectChange(value)}
                isRequired={isTouched}
            />
            <InputInfo
                title={
                    <div>
                        <b>Privileged:</b> Select this option when authenticating with your Azure secondary ID.
                        <br />
                        <b>Non-Privileged:</b> Select this option when authenticating with your PepsiCo primary ID.
                    </div>
                }
            />
        </Box>
    );
};

ActiveDirectoryGroupType.propTypes = {
    index: PropTypes.number,
};

ActiveDirectoryGroupType.defaultProps = {
    index: undefined,
};

export default ActiveDirectoryGroupType;
